'use strict';

import svg4everybody from 'svg4everybody';
import whatInput from 'what-input';
import lazyLoad from 'vanilla-lazyload';

const lazyLoadOptions = {/* your options here */ };
const pageLazyLoad = new lazyLoad(lazyLoadOptions);

svg4everybody();
